import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import React from 'react';
import * as TableStyles from '../../styles';

type ThumbnailWithFallbackProps = {
  url: string | undefined;
  alt?: string;
};

const ThumbnailWithFallback: React.FC<ThumbnailWithFallbackProps> = ({
  url,
  alt = 'episode artwork',
}) =>
  url ? <TableStyles.Img src={url} alt={alt} /> : <ImageNotSupportedIcon />;

export default ThumbnailWithFallback;
